// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"9d273fdb","800":"d5034790"}[chunkId] + ".chunk.js";
};